import { useTranslation } from 'react-i18next';
import { Breadcrumbs, Typography, Paper } from '@mui/material';
import { useAuth } from '@contexts/AuthContext';
import Layout from '@components/Layout';

function HomePage() {
    const { t } = useTranslation();
    const { user } = useAuth();

    return (
        <Layout>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                <Typography>{t('Home')}</Typography>
            </Breadcrumbs>
            <Paper sx={{ p: 2 }}>
                <Typography variant="h4">Bienvenue {user ? user.user_full_name : ''} !</Typography>
            </Paper>
        </Layout>
    );
}

export default HomePage;
